export const typeServicesOptions = [
  {'text': '', 'value': ''},
  {'text': 'Servicio', 'value': 'SERVICE'},
  {'text': 'Accesorios', 'value': 'ACCESSORIES'},
];

export const priorities = {
  'SERIOUS': 'Grave',
  'HIGH': 'Alta',
  'MEDIUM': 'Media',
  'LOW': 'Baja',
};

export const types = {
  'SERVICE': 'Servicio',
  'ACCESSORIES': 'Accesorios',
};

export const ofpStatus = {
  'AVAILABLE': 'Disponible',
  'NON AVAILABLE': 'No Disponible',
};
